import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PracticeAreaCard = ({
  icon,
  title,
  description,
  features,
  consultationPrice,
  successRate,
  caseExample,
  isPopular = false,
  phoneNumber
}) => {
  return (
    <div className={`relative bg-white rounded-xl shadow-professional border transition-all duration-300 hover:shadow-elevated hover:-translate-y-1 ${
    isPopular ? 'border-primary ring-2 ring-primary/20' : 'border-slate-200'}`
    }>
      {isPopular &&
      <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary text-white px-4 py-1 rounded-full text-sm font-medium">beliebt

        </span>
        </div>
      }
      <div className="p-6">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className={`p-3 rounded-lg ${
            isPopular ? 'bg-primary text-white' : 'bg-primary/10 text-primary'}`
            }>
              <Icon name={icon} size={24} strokeWidth={2} />
            </div>
            <div>
              <h3 className="text-xl font-bold text-text-primary">{title}</h3>
              <div className="flex items-center space-x-2 mt-1">
                <span className="text-sm text-text-secondary">{consultationPrice} EUR/Min</span>
              </div>
            </div>
          </div>
        </div>

        {/* Description */}
        <p className="text-text-secondary mb-4 leading-relaxed">
          {description}
        </p>

        {/* Features */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-text-primary mb-2">Unsere Leistungen:</h4>
          <ul className="space-y-1">
            {features?.map((feature, index) =>
            <li key={index} className="flex items-center space-x-2 text-sm text-text-secondary">
                <Icon name="Check" size={16} className="text-success flex-shrink-0" />
                <span>{feature}</span>
              </li>
            )}
          </ul>
        </div>

        {/* Case Example */}
        <div className="bg-muted rounded-lg p-4 mb-4">
          <h4 className="text-sm font-semibold text-text-primary mb-2 flex items-center">
            <Icon name="FileText" size={16} className="mr-2" />
            Erfolgsbeispiel
          </h4>
          <p className="text-sm text-text-secondary italic">
            "{caseExample}"
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <a href={`tel:${phoneNumber?.replace(/\s+/g, '')}`} className="flex-1">
            <Button
              variant="default"
              size="sm"
              iconName="Phone"
              iconPosition="left"
              className="w-full bg-conversion-accent hover:bg-cta text-white">

              Sofort anrufen
            </Button>
          </a>
          <Button
            variant="outline"
            size="sm"
            iconName="Calendar"
            iconPosition="left"
            className="flex-1">

            Termin buchen
          </Button>
        </div>
      </div>
    </div>);

};

export default PracticeAreaCard;